import * as Yup from "yup"

export const stripOnCast = cast => origSchema =>
  // @ts-ignore
  Yup.lazy((value: any, config: any) => {
    if (config.context?.cast === cast) {
      // Store stripped value in context so other validation can still use original value,
      // for instance Yup.ref("$well.id") if stripping the well field.
      config.context[config.path] = value
      return origSchema.strip(true)
    }
    return origSchema
  })

export const updateStrip = stripOnCast("update")
export const createStrip = stripOnCast("create")
